import { render, staticRenderFns } from "./onlineClassroom.vue?vue&type=template&id=16bfaa82&scoped=true&"
import script from "./onlineClassroom.vue?vue&type=script&lang=js&"
export * from "./onlineClassroom.vue?vue&type=script&lang=js&"
import style0 from "./onlineClassroom.vue?vue&type=style&index=0&id=16bfaa82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bfaa82",
  null
  
)

export default component.exports